import React from 'react';
import { Navigation } from 'lucide-react';
import { Message } from '../../types/assistantTypes';

interface MessageBubbleProps {
    message: Message;
    onAction: (action: { type: 'highlight' | 'navigate', target: string }) => void;
}

export const MessageBubble: React.FC<MessageBubbleProps> = ({ message, onAction }) => {
    return (
        <div className={`flex ${message.role === 'user' ? 'justify-end' : 'justify-start'}`}>
            <div
                className={`max-w-[85%] rounded-xl p-3 shadow-md ${message.role === 'user'
                    ? 'bg-gradient-to-br from-blue-500 to-blue-600 text-white'
                    : 'bg-white dark:bg-slate-700 border-2 border-blue-100 dark:border-blue-800 text-slate-900 dark:text-gray-100'
                    }`}
            >
                <div className="text-sm leading-relaxed space-y-1">
                    {message.content.split('\n').map((line, i) => {
                        // Handle lists
                        const isList = line.trim().startsWith('•') || line.trim().startsWith('-');

                        // Handle bolding
                        const parts = line.split(/(\*\*.*?\*\*)/g);

                        return (
                            <div key={i} className={`${isList ? 'pl-4 relative' : 'min-h-[6px]'}`}>
                                {isList && <span className="absolute left-0">•</span>}
                                {parts.map((part, j) => {
                                    if (part.startsWith('**') && part.endsWith('**')) {
                                        return <strong key={j} className="font-bold">{part.slice(2, -2)}</strong>;
                                    }
                                    return <span key={j}>{part.replace(/^[•-]\s*/, '')}</span>;
                                })}
                            </div>
                        );
                    })}
                </div>
                {message.action && (
                    <button
                        onClick={() => onAction(message.action!)}
                        className="mt-2 text-xs bg-blue-500 hover:bg-blue-600 text-white px-3 py-1.5 rounded-lg transition-colors flex items-center gap-1 shadow-sm"
                    >
                        <Navigation size={12} />
                        {message.action.label}
                    </button>
                )}
            </div>
        </div>
    );
};
